/**
 * Migração de localStorage legado para sistema de onboarding no banco de dados
 * Executado apenas uma vez para limpar dados antigos
 */
export const migrateLegacyOnboarding = () => {
  const legacyKeys = [
    'vyra-onboarding-completed',
    'vyra_tutorial_dismissed',
    'vyra_capture_tip_dismissed',
  ];
  
  let migratedCount = 0;
  
  legacyKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`[Migration] Removing legacy key: ${key}`);
      localStorage.removeItem(key);
      migratedCount++;
    }
  });
  
  if (migratedCount > 0) {
    console.log(`[Migration] ✅ Cleaned up ${migratedCount} legacy onboarding keys`);
  }
  
  // Marcar migração como concluída
  localStorage.setItem('vyra-onboarding-migrated', 'true');
};
